import angular from 'angular';
import constants from 'app/constants';
import {
  assetDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './delete-assetType-confirm-dialog.controller';
import template from './delete-assetType-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    assetType, 
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'deleteConfirmDialogVM',
      locals: {
        assetType,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.asset.deleteAssetTypeConfirmDialog', [
  alerts,
  assetDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('deleteAssetTypeConfirmDialog', dialogService)
  .name;
